// packages import
import { Box, useMediaQuery } from '@mui/material'
import { FC } from 'react'
// component import
import { CasesFilter } from './CasesFilter'
import { FilterDrawer } from './FilterDrawer'
// others
import { FilterDrawerProps } from '../../interfaceTypes'

export const FilterWrapper: FC<FilterDrawerProps> = ({ casesLength, sortByUser, showClient = true, loading, refetch, fetchAllCases }) => {
  const smallViewport = useMediaQuery('(max-width:900px)')

  return smallViewport ? (
    <FilterDrawer casesLength={casesLength!} sortByUser={sortByUser} showClient={showClient} loading={loading} mode="full" refetch={refetch} fetchAllCases={fetchAllCases} />
  ) : (
    <Box width="100%" display="flex" gap={2} alignItems="baseline">
      <Box flex={1} >
        <CasesFilter
          casesLength={casesLength!}
          sortByUser={sortByUser}
          showClient={showClient}
          showLawType={false}
          showOffice={false}
          showSortByUser={false}
          showExport={false}
          showReset={false}
          loading={loading}
          refetch={refetch}
          fetchAllCases={fetchAllCases}
        />
      </Box>
      <FilterDrawer casesLength={casesLength!} sortByUser={sortByUser} showClient={showClient} loading={loading} mode="extras" refetch={refetch} fetchAllCases={fetchAllCases} />
    </Box>
  )
  // : (
  //   <Box width="100%">
  //     <CasesFilter casesLength={casesLength!} sortByUser={sortByUser} />
  //   </Box>
  // )
}
